import { v4 as uuidv4 } from 'uuid';
var Initialize = /** @class */ (function () {
    function Initialize() {
        Object.defineProperty(this, "emptyCompany", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                legalBusinessName: '',
                incorporationNr: '',
                email: '',
                vatId: '',
                skype: '',
                businessPhone: '',
                customerServicePhone: '',
                country: '',
                dateEstablished: new Date(),
                regStreetAddress: '',
                regCity: '',
                regCountry: '',
                regPostCode: '',
                mailStreetAddress: '',
                mailCity: '',
                mailCountry: '',
                mailPostCode: '',
                typeOfBusiness: '',
                operatingFrom: [],
                departments: '',
                numberOfEmployees: 0,
                operationalStreetAddress: '',
                operationalStreetCity: '',
                operationalStreetCountry: '',
                operationalStreetPostalCode: '',
            }
        });
        Object.defineProperty(this, "emptyOwner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                id: uuidv4(),
                name: '',
                percentOwnership: 0,
                ownerSince: undefined,
                role: undefined,
                currentAddressCity: '',
                currentAddressCountry: '',
                currentAddressPostcode: '',
                currentAddressStreet: '',
                previousAddressCity: '',
                previousAddressCountry: '',
                previousAddressPostCode: '',
                previousAddressStreet: '',
                socialSecurityNr: '',
                mobilePhoneNr: '',
                dateOfBirth: undefined,
                personalEmail: '',
                driverLicense: '',
                passport: '',
                nationality: '',
                passportCountryOfIssue: '',
                isAuthorizedSignatory: undefined,
                isMain: true
            }
        });
        Object.defineProperty(this, "emptyWebsite", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                id: uuidv4(),
                url: '',
                industry: '',
                description: '',
                isOfferMembershipArea: false,
                testUserId: '',
                testPassword: '',
                isMain: true
            }
        });
        Object.defineProperty(this, "emptyProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                estimatedMonthlyVolume: undefined,
                pricingModel: "None",
                averageTicketAmount: undefined,
                highestTicketAmount: undefined,
                lowestTicketAmount: undefined,
                averageNumberOfTransactions: undefined,
                averageRefundRatio: undefined,
                averageChargebackRatio: undefined,
                majorRegionsYourTraficIsComingFrom: {
                    eu: 0,
                    usa: 0,
                    asia: 0,
                    row: 0
                },
                targetMarkets: "",
                haveYouAcceptedCreditCardPayment: false,
                processorPayment: "",
                processorAccountId: "",
                processorTimePeriod: undefined,
                isRelationshipTerminated: undefined,
                reasonOfTermination: "",
                isBlacklisted: undefined,
                requiredProcessingCurriencies: "",
                requiredSettlementsCurriencies: "",
                requiredMoto: undefined,
                percentViaMoto: undefined,
                percentViaCreditCard: undefined,
                require3Dprocessing: undefined,
                requiredCardBrands: [],
                requestedAPMs: "",
                paymentStatementDescriptorLine1: "",
                paymentStatementDescriptorLine2: ""
            }
        });
        Object.defineProperty(this, "emptyIntergation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                isAssistanceNeeded: undefined,
                isDeveloperAvailable: undefined,
                isMembershipOffering: undefined,
                isShoppingCartAvailable: undefined,
                shoppingCart: '',
                isCashierSystemAvailable: undefined,
                cashierSystem: '',
                isPCICompliant: undefined,
                pciCompliantCertificate: '',
                isPCICompliantPaymentGatewayUsed: undefined,
                pciCompliantPaymentGateway: ''
            }
        });
    }
    return Initialize;
}());
export { Initialize };
